import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { TextField } from '@mui/material';
import { getIn } from 'formik';

const EquipmentFields = ({
  basePath,
  errors,
  touched,
  handleBlur,
  handleChange,
  values,
  isEditable
}) => {
  const { t } = useTranslation();
  return (
    <>
      <TextField
        InputProps={{ autoComplete: 'off' }}
        error={Boolean(
          getIn(touched, `${basePath}.brand`) &&
            getIn(errors, `${basePath}.brand`)
        )}
        fullWidth
        helperText={
          getIn(touched, `${basePath}.brand`) &&
          t(getIn(errors, `${basePath}.brand`))
        }
        label={t('COMMON.BRAND')}
        margin="normal"
        name={`${basePath}.brand`}
        disabled={!isEditable}
        onBlur={handleBlur}
        onChange={handleChange}
        type="text"
        value={
          getIn(values, `${basePath}.brand.name`) ||
          getIn(values, `${basePath}.brand`) ||
          ''
        }
        variant="outlined"
      />
      <TextField
        InputProps={{ autoComplete: 'off' }}
        error={Boolean(
          getIn(touched, `${basePath}.model`) &&
            getIn(errors, `${basePath}.model`)
        )}
        fullWidth
        helperText={
          getIn(touched, `${basePath}.model`) &&
          t(getIn(errors, `${basePath}.model`))
        }
        label={t('COMMON.MODEL')}
        margin="normal"
        name={`${basePath}.model`}
        disabled={!isEditable}
        onBlur={handleBlur}
        onChange={handleChange}
        type="text"
        value={getIn(values, `${basePath}.model`) || ''}
        variant="outlined"
      />
    </>
  );
};

EquipmentFields.propTypes = {
  basePath: PropTypes.string.isRequired,
  errors: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired,
  handleBlur: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  isEditable: PropTypes.bool.isRequired
};

export default EquipmentFields;
